export default __webpack_public_path__ + "locales/lo-LA/PreparationPortal.json?hash=e073172cd23ecfdfdcaa79da8ad323cc";